import React from 'react'
import { IconSolid } from './Icon'

/**
 * ModalTriggerButton - Wiederverwendbarer Button für Modal-Trigger
 * 
 * Standardisierter Button-Component für konsistente Modal-Trigger
 * in Übungen und Workshops
 */

export interface ModalTriggerButtonProps {
  onClick: () => void
  icon?: string
  text: string
  theme?: 'blue' | 'green' | 'amber' | 'purple' | 'gray'
  className?: string
}

const themeStyles = {
  blue: 'bg-blue-600 hover:bg-blue-700 border-blue-500',
  green: 'bg-green-600 hover:bg-green-700 border-green-500',
  amber: 'bg-amber-600 hover:bg-amber-700 border-amber-500',
  purple: 'bg-purple-600 hover:bg-purple-700 border-purple-500',
  gray: 'bg-muted hover:bg-muted/80 border-border',
}

export const ModalTriggerButton: React.FC<ModalTriggerButtonProps> = ({
  onClick,
  icon = 'info-circle',
  text,
  theme = 'blue',
  className = '',
}) => {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-2 px-6 py-3 text-white rounded-lg hover:shadow-lg transition-all duration-200 border-2 ${themeStyles[theme]} ${className}`}
    >
      <IconSolid name={icon} className="w-5 h-5" />
      <span>{text}</span>
    </button>
  )
}

ModalTriggerButton.displayName = 'ModalTriggerButton'

export default ModalTriggerButton
